import type { TRPCLink } from "@trpc/client";
import { observable } from "@trpc/server/observable";
import type { AppRouter } from "@bookdental/api";

/** As mesmas mensagens de `packages/api/src/lib/pin.ts`. */
const PIN_REQUERIDO = "Confirme seu PIN para continuar.";
const PIN_NAO_CRIADO = "Crie um PIN para continuar.";

export type ModoDoPin = "confirmar" | "criar" | "redefinir";
type PedirPin = (modo: ModoDoPin) => Promise<boolean>;

let pedirPin: PedirPin | null = null;
/** Abrir o diálogo fora de uma ação (ex.: Meu perfil → Criar/Redefinir PIN). */
export const abrirDialogoDePin = (modo: ModoDoPin) => pedirPin?.(modo);

/** O `PinProvider` registra aqui quem abre o diálogo. */
export const registrarPedidoDePin = (f: PedirPin | null) => {
  pedirPin = f;
};

/**
 * Ação sensível (preço, transferência, sócio) que o servidor recusa por falta de PIN não chega a
 * virar erro na tela: o link pede o PIN e repete a MESMA chamada. Nenhuma tela precisa saber que
 * existe PIN — cancelar o diálogo devolve o erro original.
 */
export const pinLink: TRPCLink<AppRouter> = () => ({ next, op }) =>
  observable((observer) => {
    let sub = next(op).subscribe({
      next: (v) => observer.next(v),
      error: (err) => {
        const msg = err.message;
        if (op.type !== "mutation" || !pedirPin || (msg !== PIN_REQUERIDO && msg !== PIN_NAO_CRIADO)) {
          observer.error(err);
          return;
        }
        pedirPin(msg === PIN_NAO_CRIADO ? "criar" : "confirmar").then((ok) => {
          if (!ok) {
            observer.error(err);
            return;
          }
          sub = next(op).subscribe({
            next: (v) => observer.next(v),
            error: (e) => observer.error(e),
            complete: () => observer.complete(),
          });
        });
      },
      complete: () => observer.complete(),
    });
    return () => sub.unsubscribe();
  });
